import React from 'react';
import { Link } from 'react-router-dom';

/** Breadcrumb which is compatible with any number of navigation links */
const Breadcrumb = ({ list, classes = '' }) => {
  const length = list.length;
  return (
    <nav className={'flex ' + classes} aria-label='Breadcrumb'>
      <ol className='flex items-center space-x-0 mb-0'>
        <li>
          <div className='flex items-center'>
            <Link to={list[0].link} className='text-xs text-gray-400 hover:text-gray-600'>
              {list[0].text}
            </Link>
          </div>
        </li>
        {list.slice(1).map(({ text, link }, index) => {
          return (
            <li key={link}>
              <div className='flex items-center'>
                <span className='mx-1 text-gray-500'>/</span>
                {
                  link === '#' ?
                  <div
                    className={
                      `cursor-pointer text-xs text-gray-400 hover:text-gray-600 ` + (index === length - 2 ? 'font-semibold' : '')
                    }
                    aria-current='page'
                  >{text}</div>:
                  <Link
                    to={link}
                    className={
                      `cursor-pointer text-xs text-gray-400 hover:text-gray-600 ` + (index === length - 2 ? 'font-semibold' : '')
                    }
                    aria-current='page'
                >
                  {text}
                </Link>
                }
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
